import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout } from '../actions/constants'

export interface ITemporaryDataState {
  authenticatedRequestsReady: boolean,
  lastActive: number | null,
  networkFailures: number
}

const initialState: ITemporaryDataState = {
  authenticatedRequestsReady: false,
  lastActive: null,
  networkFailures: 0
}

export const temporaryDataSlice = createSlice({
  name: 'temporaryData',
  initialState,
  reducers: {
    setAuthenticatedRequestsReady: (state, action: PayloadAction<boolean>) => {
      state.authenticatedRequestsReady = action.payload
    },
    setLastActive: (state, action: PayloadAction<number | null>) => {
      state.lastActive = action.payload
    },
    setNetworkFailures: (state, action: PayloadAction<number>) => {
      state.networkFailures = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  }
})

export const {
  setAuthenticatedRequestsReady,
  setLastActive,
  setNetworkFailures
} = temporaryDataSlice.actions

export default temporaryDataSlice.reducer
